import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/frontend/app/components/cursor/cursor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/frontend/app/components/KlaroClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/frontend/app/components/navigation/nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/frontend/app/components/UserbackWidget.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/components/VisualEditingComp.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/workspace/frontend/app/provider/AppProvider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ViewTransitions"] */ "/workspace/frontend/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/FFF-AcidGrotesk-Medium.otf\",\"weight\":\"500\",\"variable\":\"--font-fff-acid-grotesk-bold\"}],\"variableName\":\"bold\"}");
;
import(/* webpackMode: "eager" */ "/workspace/frontend/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/FFF-AcidGrotesk-Regular.otf\",\"weight\":\"400\",\"variable\":\"--font-fff-acid-grotesk\"}],\"variableName\":\"normal\"}");
